"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snapchat1Schema = void 0;
exports.Snapchat1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/snapchat-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Snapchat1",
    "description": "Adds a button to add people on snapchat",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:snapchat-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "href": {
                    "type": "string",
                    "description": "e.g. `https://www.snapchat.com/add/redbull/`"
                }
            },
            "required": [
                "href"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zbmFwY2hhdC1zb2NpYWxsaW5rLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZUFBZSxHQUFHO0lBQzdCLEtBQUssRUFBRSx3RkFBd0Y7SUFDL0YsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsV0FBVztJQUNwQixhQUFhLEVBQUUseUNBQXlDO0lBQ3hELE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixnREFBZ0Q7YUFDakQ7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSw4Q0FBOEM7aUJBQzlEO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsTUFBTTthQUNQO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=